import { render, staticRenderFns } from "./areaContent.vue?vue&type=template&id=4b1a6026&"
import script from "./areaContent.vue?vue&type=script&lang=js&"
export * from "./areaContent.vue?vue&type=script&lang=js&"
import style0 from "./areaContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports